module.exports = {"apiUrl":"","apiBasePath":"WAKBAPI"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config.json
// module id = ./src/assets/config.json
// module chunks = main